var render = function render(_c,_vm){return _c('div',{staticClass:"mr-1 vendor-icon-container"},[_c('img',{staticClass:"vendor-icon",attrs:{"aria-hidden":"","src":_vm.props.vendor.url,"alt":_vm.props.vendor.name,"title":_vm.props.vendor.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }